import React, {Component} from 'react'
import CountUp from "react-countup";

class Score extends Component {
    render() {
        return (
            <div>
                <h3 className="font-weight-light counter">
                    <CountUp end={this.props.score} duration={2}/>
                </h3>
                <span>{this.props.name}</span>
            </div>
        );
    }
}

export default Score